import React, { useState } from 'react';
import './index.css';

const Contact = () => {

    const [formInputs, setFormInputs] = useState({
        email: '',
        message: ''
    });

    const [validation, setValidations] = useState({
        email: null,
        message: null
    });

    const updateInputValues = (e) => {
        const { value, name } = e.target;

        setFormInputs({
            ...formInputs,
            [name]: value
        });
    }

    const submitMessage = (e) => {
        e.preventDefault();
        console.log(formInputs);
    }

    const { email, message } = formInputs;
    const { emailValidation, messageValidation } = validation;

    return (
        <div className="form-contact">
            <div className="form-wrapper">
                <h1 className="form-contact-title">Ready to hear from you </h1>
                <div className="horizontal-line"></div>
                <form onSubmit={submitMessage}>
                    <div className="form-group">
                        <input onChange={updateInputValues} value={email} name="email" className="form-control" placeholder="EMAIL ADDRESS HERE .." />
                        {!emailValidation && <p className="error-message">Your email address is needed</p>}
                    </div>
                    <div className="form-group">
                        <textarea onChange={updateInputValues} value={message} className="form-control" name="message" placeholder="YOUR MESSAGE HERE ..">{message}</textarea>
                        {!messageValidation && <p className="error-message">Message field cannot be empty.</p>}
                    </div>
                    <div className="form-group">
                        <button className="form-control-button">send message</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Contact;